import { DbDeviceConfig } from "api"

export default function DeviceConfigRaw({ props }: { props: DbDeviceConfig }) {
	return <pre>{JSON.stringify(props, null, "\t")}</pre>
}
